import { Navigate, useParams } from "react-router-dom";
import Step3Connected from "./Step3-Connected";
import Step3InUse from "./Step3-InUse";
import Step3NoAccount from "./Step3-NoAccount";

function Step3() {
    const { variant } = useParams<{ variant: string }>();

    switch (variant) {
        case "connected":
            return <Step3Connected />;
        case "no-account":
            return <Step3NoAccount />;
        case "in-use":
            return <Step3InUse />;
        default:
            // Unknown variant — bounce to Step 1
            return <Navigate to="/jobber-homedepot-step1" replace />;
    }
}

export default Step3;
